export const LOAD_DISCOUNTS_SUCCESS = "LOAD_DISCOUNTS_SUCCESS";
export const LOAD_DISCOUNT_SUCCESS = "LOAD_DISCOUNT_SUCCESS";
export const LOAD_DISCOUNT_LOADING = "LOAD_DISCOUNT_LOADING";
export const LOAD_DISCOUNT_FAILED = "LOAD_DISCOUNT_FAILED";
